import { site } from "@/content/site";

const items = [
  { label: "Training", value: "Monday \u2013 Thursday" },
  { label: "Hours", value: "6:00pm \u2013 8:00pm" },
  { label: "Location", value: "Membertou, NS" },
  { label: "Experience", value: "No experience necessary" },
] as const;

export function QuickInfoBar() {
  return (
    <section
      aria-label={`${site.name} quick info`}
      style={{ backgroundColor: "#151515", color: "#fff", borderTop: "1px solid #333" }}
    >
      <div className="container-page py-5 sm:py-6">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 list-none p-0 m-0">
          {items.map((item) => (
            <li
              key={item.label}
              className="flex items-start gap-3 sm:flex-col sm:gap-1"
            >
              <span
                className="text-xs font-bold uppercase tracking-[0.2em] shrink-0"
                style={{ color: "#d71920" }}
              >
                {item.label}
              </span>
              <span className="text-sm sm:text-base font-medium" style={{ color: "rgba(255,255,255,0.9)" }}>
                {item.value}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
